import React, { ReactNode } from 'react';
import { Row } from 'reactstrap';
import { UpsertEmailTemplateDto } from '../../containers/EmailTemplates/SetupEmailTemplatePage/UpsertEmailTemplateDto';
import { EmailTemplateInput } from './EmailTemplateInput';
import { Footer } from './Footer';
import { SubjectInput } from './SubjectInput';
import { Control, FieldErrors, FieldArrayWithId } from 'react-hook-form';
import { FileError } from 'use-file-picker';
import { EmailTemplate } from '../../entities/EmailTemplate';
import { Size } from '../../utils/types/Size';
import classNames from 'classnames';

interface PropTypes {
  control: Control<UpsertEmailTemplateDto, any>;
  errors: FieldErrors;
  footerFields: FieldArrayWithId<UpsertEmailTemplateDto, 'attachments', 'id'>[];
  filePickerErrors: FileError[];
  referenceTemplate?: EmailTemplate | UpsertEmailTemplateDto;
  title?: string;
  subjectColSize?: number;
  bodyTitle?: string;
  bodyColSize?: number;
  bodyFooter?: ReactNode;
  bodySize?: Size;
  className?: string;
  skipAttachments?: boolean;
  handleRemoveField: (index: number) => void;
  openFileSelector: () => void;
  setHtml: (html: string) => void;
  setSubjectText: (text: string) => void;
}

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILES = 6;
export const MAX_FILES_SIZE_MB = 20;

export function emailTemplateToDto(
  emailTemplate?: EmailTemplate,
): UpsertEmailTemplateDto {
  return {
    id: emailTemplate?.id,
    name: emailTemplate?.name,
    emailTemplateReferenceId: emailTemplate?.emailTemplateReferenceId,
    subject: emailTemplate?.subject,
    subjectText: emailTemplate?.subjectText,
    template: emailTemplate?.template,
    templateHtml: emailTemplate?.templateHtml,
    attachments: emailTemplate?.attachments,
  };
}

export function EmailTemplateEditor(props: PropTypes) {
  return (
    <div className={classNames(props.className)}>
      <Row className='my-4'>
        <SubjectInput
          control={props.control}
          subject={props.referenceTemplate?.subject}
          title={props.title}
          colSize={props.subjectColSize}
          setSubjectText={props.setSubjectText}
        />
      </Row>
      <EmailTemplateInput
        control={props.control}
        title={props.bodyTitle}
        colSize={props.bodyColSize}
        footer={props.bodyFooter}
        template={props.referenceTemplate?.template}
        size={props.bodySize}
        setHtml={props.setHtml}
      />
      {!props.skipAttachments && (
        <Footer
          fields={props.footerFields}
          errors={props.filePickerErrors}
          onRemoveField={props.handleRemoveField}
          openFileSelector={props.openFileSelector}
        />
      )}
    </div>
  );
}
